// Sublinhado no dialeto da casa: `++texto++`. O markdown não tem sublinhado;
// o agente usa a mesma marca no Word e em Petições. Regra do par (a mesma do
// agente): exatamente dois `+` (sem um terceiro colado), abre quando o
// caractere seguinte não é espaço, fecha quando o anterior não é espaço, o
// conteúdo não é vazio e não há sublinhado dentro de sublinhado.

// `\+` no texto-fonte vira estes dois caracteres antes da análise: mesmo
// comprimento, então as posições do markdown não mudam.
export const MAIS_ESCAPADO = '';
// "+" que veio escapado: aparece como "+", mas não abre nem fecha sublinhado
export const MAIS_LITERAL = '';

export const protegerMaisEscapado = (markdown: string): string =>
  markdown.replace(/\\([\\+])/g, (trecho: string, caractere: string) =>
    caractere === '+' ? MAIS_ESCAPADO : trecho,
  );

// O texto já analisado: o "+" escapado vira o literal, que não forma par
export const marcarMaisEscapado = (texto: string): string =>
  texto.split(MAIS_ESCAPADO).join(MAIS_LITERAL);

// Dentro de código o `\+` é texto: volta a ser barra e "+"
export const restaurarMaisEscapado = (texto: string): string =>
  texto.split(MAIS_ESCAPADO).join('\\+');

export const semMaisLiteral = (texto: string): string => texto.split(MAIS_LITERAL).join('+');

export interface Trecho {
  texto: string;
  // Código, quebra e afins: contam como vizinhança, mas não delimitam
  literal: boolean;
}

// Pares [abertura, fechamento] como posições do texto concatenado dos trechos
// (cada delimitador ocupa duas posições a partir dali)
export const parearSublinhado = (trechos: Trecho[]): number[][] => {
  let texto = '';
  const delimita: boolean[] = [];
  // Trecho de cada caractere: a sequência de "+" é contada só dentro do mesmo
  // trecho (o `++` que fecha antes de um `**` não emenda no `++` seguinte)
  const dono: number[] = [];
  trechos.forEach((trecho, indice) => {
    texto += trecho.texto;
    for (let i = 0; i < trecho.texto.length; i += 1) {
      delimita.push(!trecho.literal);
      dono.push(indice);
    }
  });
  const mais = (i: number, vizinho: number) =>
    vizinho >= 0 && vizinho < texto.length && dono[vizinho] === dono[i] && texto[vizinho] === '+';

  const pares: number[][] = [];
  let aberto = -1;
  for (let i = 0; i + 1 < texto.length; i += 1) {
    const ehPar =
      texto[i] === '+' &&
      texto[i + 1] === '+' &&
      delimita[i] &&
      delimita[i + 1] &&
      dono[i] === dono[i + 1] &&
      !mais(i, i - 1) &&
      !mais(i + 1, i + 2);
    if (ehPar) {
      const antes = texto[i - 1];
      const depois = texto[i + 2];
      const abre = depois !== undefined && !/\s/.test(depois);
      const fecha = antes !== undefined && !/\s/.test(antes);
      if (aberto >= 0 && fecha && i > aberto + 2) {
        pares.push([aberto, i]);
        aberto = -1;
      } else if (abre) {
        aberto = i;
      }
      i += 1;
    }
  }
  return pares;
};
